/**
 * ENV_FLAG_MAP
 *
 * Maps VITE_FF_* environment variable names to their permissionService flag keys.
 * Env vars use UPPER_SNAKE_CASE; flag keys use dot/hyphen notation.
 *
 * Set any of these in .env.{environment} to override the featureFlags.json default.
 *
 * Example (.env.production):
 *   VITE_FF_CAMERAS_FEATURE_DEMO=false
 *   VITE_FF_BUSINESS_INTELLIGENCE=false
 */
export const ENV_FLAG_MAP: Record<string, string> = {
  VITE_FF_BILLING: 'billing',
  VITE_FF_BILLING_DASHBOARD: 'billing.dashboard',
  VITE_FF_BILLING_SUBSCRIPTIONS: 'billing.subscriptions',
  VITE_FF_BILLING_PAYMENT_METHODS: 'billing.payment-methods',
  VITE_FF_BILLING_HISTORY: 'billing.history',
  VITE_FF_DASHBOARD: 'dashboard',
  VITE_FF_BUSINESS_INTELLIGENCE: 'business-intelligence',
  VITE_FF_LOCATIONS: 'locations',
  VITE_FF_DEVICES: 'devices',
  VITE_FF_HVAC: 'hvac',
  VITE_FF_HVAC_STATUS: 'hvac.status',
  VITE_FF_HVAC_HUMIDITY: 'hvac.humidity',
  VITE_FF_HVAC_HEALTH: 'hvac.health',
  VITE_FF_HVAC_SCHEDULE: 'hvac.schedule',
  VITE_FF_HVAC_REPORTS: 'hvac.reports',
  VITE_FF_HVAC_SETTINGS: 'hvac.settings',
  VITE_FF_ACCESS: 'access',
  VITE_FF_ACCESS_STATUS: 'access.status',
  VITE_FF_ACCESS_HEALTH: 'access.health',
  VITE_FF_ACCESS_SCHEDULE: 'access.schedule',
  VITE_FF_ACCESS_REPORTS: 'access.reports',
  VITE_FF_ACCESS_SETTINGS: 'access.settings',
  VITE_FF_CAMERAS: 'cameras',
  VITE_FF_CAMERAS_LIVE: 'cameras.live',
  VITE_FF_CAMERAS_AI_SEARCH: 'cameras.ai-search',
  VITE_FF_CAMERAS_EVENTS: 'cameras.events',
  VITE_FF_CAMERAS_CLIPS: 'cameras.clips',
  VITE_FF_CAMERAS_SMART_DETECTION: 'cameras.smart-detection',
  VITE_FF_CAMERAS_FEATURE_DEMO: 'cameras.feature-demo',
  VITE_FF_CAMERAS_ARMING_MODES: 'cameras.arming-modes',
  VITE_FF_CAMERAS_DETERRENCE: 'cameras.deterrence',
  VITE_FF_CAMERAS_ADD_CAMERA: 'cameras.add-camera',
  VITE_FF_CAMERAS_RECORDING_SCHEDULE: 'cameras.recording-schedule',
  VITE_FF_CAMERAS_ENTITLEMENT: 'cameras.entitlement',
  VITE_FF_ALERTS: 'alerts',
  VITE_FF_EMPLOYEES: 'employees',
  VITE_FF_AUTOMATIONS: 'automations',
  VITE_FF_NOTIFICATIONS: 'notifications',
  VITE_FF_REPORTS: 'reports',
  VITE_FF_ORG_SETTINGS: 'org-settings',
  VITE_FF_REDIRECT_TO_PRO_PORTAL: 'redirect-to-pro-portal',
  VITE_FF_WELCOME_ONBOARDING: 'welcome-onboarding',
  VITE_FF_DASHBOARD_CUSTOMIZE: 'dashboard.customize',
  VITE_FF_DASHBOARD_CAMERA_ONLINE_MODAL: 'dashboard.camera-online-modal',
  VITE_FF_DASHBOARD_HVAC_ONLINE_MODAL: 'dashboard.hvac-online-modal',
};
